$(function () {
    $('.mxm_securearea a.foldercreate').on('click', function (e) {
        e.preventDefault();

        var url = $(location).attr('href');
        var fid = $(this).data('fid');

        $.confirm({
            title: 'Ordner erstellen',
            content: '' +
            '<form action="'+url+'" id="mxm-securearea-folder-form" method="post">' +
            '<div class="form-group">' +
            '<label>Ordername</label>' +
            '<input type="text" name="mxm-securearea[folder-name]" placeholder="" class="title form-control" required />' +
            '</div>' +
            '</form>',
            buttons: {
                formSubmit: {
                    text: 'Erstellen',
                    btnClass: 'btn-blue',
                    action: function () {
                        var name = this.$content.find('.title').val();
                        if (!name) {
                            $.alert('Bitte Ordnernamen eingeben.');
                            return false;
                        }
                        var form = $("#mxm-securearea-folder-form");

                        form.attr('action', $(location).attr('href'));
                        form[0].submit();
                    }
                },
                cancel: function () {
                    //close
                },
            },
            onContentReady: function () {
                // bind to events
                var jc = this;
                this.$content.find('form').on('submit', function (e) {
                    // if the user submits the form by pressing enter in the field.
                    e.preventDefault();
                    jc.$$formSubmit.trigger('click'); // reference the button and click it
                });
            }
        });
    });

    $('.mxm_securearea a.fileupload').on('click', function (e) {
        e.preventDefault();
        //console.log("href: "+$(location).attr('href'))

        var url = $(location).attr('href');
        var fid = $(this).data('fid');


        $.confirm({
            title: 'Datei hochladen',
            content: '' +
            '<form action="'+url+'" id="mxm-securearea-upload-form" method="post" enctype="multipart/form-data">' +
            '<div class="form-group">' +
            '<label>Titel</label>' +
            '<input type="text" name="mxm-securearea[upload-name]" placeholder="" class="title form-control" required />' +
            '</div>' +
            '<div class="form-group">' +
            '<label>Datei</label>' +
            '<input type="file" name="mxm-securearea" class="file form-control" required />' +
            '</div>' +
            '</form>',
            buttons: {
                formSubmit: {
                    text: 'Datei hochladen',
                    btnClass: 'btn-blue',
                    action: function () {
                        var name = this.$content.find('.title').val();
                        var file = this.$content.find('.file').val();
                        if (!name && !file) {
                            $.alert('Bitte Dateititel eingeben und eine Datei ausw&auml;hlen.');
                            return false;
                        }
                        else if (!name) {
                            $.alert('Bitte Dateititel eingeben.');
                            return false;
                        }
                        else if (!file) {
                            $.alert('Bitte Datei ausw&auml;hlen.');
                            return false;
                        }
                        else {
                            var extension = file.replace(/^.*\./, '');

                            if (extension == file) {
                                extension = '';
                            } else {
                                extension = extension.toLowerCase();
                            }

                            switch (extension) {
                                case 'pdf':
                                case 'zip':
                                case 'psd':
                                case 'jpg':
                                case 'jpeg':
                                case 'png':
                                case 'doc':
                                case 'docx':
                                case 'xls':
                                case 'xlsx':
                                case 'ppt':
                                case 'pptx':
                                case 'mp4':
                                case 'mp3':
                                case 'dotx':
                                case 'docm':
                                case 'mmap':
                                    break;

                                default:
                                    $.alert('Ung&uuml;ltiger Dateityp.');
                                    return false;
                            }

                        }
                        //$.alert('Die Datei wird hochgeladen...');
                        var form = $("#mxm-securearea-upload-form");

                        form.attr('action', $(location).attr('href'));
                        form[0].submit();
                        //location.reload();
                    }
                },
                cancel: function () {
                    //close
                },
            },
            onContentReady: function () {
                // bind to events
                var jc = this;
                this.$content.find('form').on('submit', function (e) {
                    // if the user submits the form by pressing enter in the field.
                    e.preventDefault();
                    jc.$$formSubmit.trigger('click'); // reference the button and click it
                });
            }
        });
    });

    $('.mxm_securearea .folderlist a.btn-delete').on('click', function (e) {
        e.preventDefault();

        var url = $(this).attr('href');
        var foldername = $(this).parents('tr').find('.foldername a').text();

        $.confirm({
            title: 'Ordner l&ouml;schen',
            content: 'Wollen Sie den Ordner &laquo;<strong>' + foldername + '</strong>&raquo; wirklich l&ouml;schen?',
            buttons: {
                confirm: function () {
                    $.alert('Der Ordner wurde gel&ouml;scht!<br />&nbsp;<br /><small>Die Seite wird nun neu geladen</small>');
                    location.reload();
                },
                cancel: function () {
                },
            }
        });
    });

    $('.mxm_securearea .filelist a.btn-delete').on('click', function (e) {
        e.preventDefault();

        var url = $(this).attr('href');
        var filename = $(this).parents('tr').find('.filename').text();

        $.confirm({
            title: 'Datei l&ouml;schen',
            content: 'Wollen Sie die Datei &laquo;<strong>' + filename + '</strong>&raquo; wirklich l&ouml;schen?',
            buttons: {
                confirm: function () {
                    $.alert('Die Datei wurde gel&ouml;scht!<br />&nbsp;<br /><small>Die Seite wird nun neu geladen</small>');
                    location.reload();
                },
                cancel: function () {
                },
            }
        });
    });
});


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/securearea/index.js
 **/